import React, { ReactElement, useContext, useState, PropsWithChildren } from 'react';

/**
 * Creates the contexts.
 */
const TimeMachineContext = React.createContext<Date>(undefined!);
const TimeMachineUpdateContext = React.createContext<(value: Date) => void>(() => { });

/**
 * Creates a hook to update the time machine date.
 */
export const useTimeMachineUpdate = () => useContext(TimeMachineUpdateContext);

/**
 * Gets the dependency provider component.
 * @param props The component properties.
 */
export function TimeMachineContextProvider(props: PropsWithChildren<{}>): ReactElement
{
    const [currentDate, setCurrentDate] = useState<Date>(undefined!);

    function setDate(date: Date): void
    {
        if (date && date.getTime() > new Date().getTime())
            date = new Date();

        setCurrentDate(date);
    }

    return (
        <TimeMachineContext.Provider value={currentDate}>
            <TimeMachineUpdateContext.Provider value={setDate}>
                {props.children}
            </TimeMachineUpdateContext.Provider>
        </TimeMachineContext.Provider>
    );
}

/**
 * Returns the time machine current date.
 * @returns {string} string representation of a date.
 */
export function useTimeMachine(): Date
{
    const timeMachineContext = useContext(TimeMachineContext);
    return timeMachineContext;
}